import { render, staticRenderFns } from "./DetailListUnderView.vue?vue&type=template&id=3c880bbc"
import script from "./DetailListUnderView.vue?vue&type=script&lang=js"
export * from "./DetailListUnderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports